export const notificationIcons = {
  order: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="icons/notification/ic_package">
        <g id="stack">
          <path
            id="Path"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.0481 20.02C13.9573 18.1401 14.2658 15.7619 15.8001 14.2225C17.3344 12.6831 19.7117 12.3668 21.5951 13.4514C23.4786 14.5361 24.3982 16.7509 23.8369 18.8506C23.2756 20.9504 21.3735 22.4109 19.2001 22.411C17.4871 22.4174 15.9023 21.5048 15.0481 20.02Z"
            fill="url(#paint0_linear_0_8848)"
          />
          <g id="Vector">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M19.1996 5.57765V12.8111C17.4829 12.8113 15.897 13.7281 15.0402 15.2157C14.1834 16.7033 14.1862 18.5352 15.0476 20.0201L9.59959 23.1651V11.1191L19.1986 5.57715L19.1996 5.57765Z"
              fill="#FFD666"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.59998 0.0351562L13.4095 2.23466L3.81048 7.77666L0.000976562 5.57716L9.59998 0.0351562Z"
              fill="#FFD666"
            />
          </g>
          <g id="Vector_2">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.6 11.1191L6.257 9.18909L15.8565 3.64709L19.199 5.57709L9.6 11.1191Z"
              fill="#FFAB00"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.6 11.1191V23.1651L0 17.6226V5.57759L0.001 5.5771L3.81 7.7766V15.7641L4.9725 15.2841L6.24 16.7241V9.19909L6.257 9.18909L9.6 11.1191Z"
              fill="#FFAB00"
            />
          </g>
          <g id="Vector_3">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M15.8565 3.64712L6.257 9.18912L3.8105 7.77662L13.4095 2.23462L15.8565 3.64712Z"
              fill="url(#paint1_linear_0_8848)"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M6.257 9.18912L6.23957 9.19907V16.7241L4.97207 15.2841L3.80957 15.7641L3.8105 7.77662L6.257 9.18912Z"
              fill="url(#paint2_linear_0_8848)"
            />
          </g>
          <g id="Vector_4">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M1.24148 17.7187C1.04818 17.7187 0.891479 17.562 0.891479 17.3687V16.0727C0.891479 15.8794 1.04818 15.7227 1.24148 15.7227C1.43478 15.7227 1.59148 15.8794 1.59148 16.0727V17.3687C1.59148 17.562 1.43478 17.7187 1.24148 17.7187Z"
              fill="#FFD666"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M2.66248 18.5502C2.46918 18.5502 2.31248 18.3935 2.31248 18.2002V17.0327C2.31248 16.8394 2.46918 16.6827 2.66248 16.6827C2.85578 16.6827 3.01248 16.8394 3.01248 17.0327V18.2002C3.01248 18.3935 2.85578 18.5502 2.66248 18.5502Z"
              fill="#FFD666"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4.08435 19.3707C3.89105 19.3707 3.73435 19.214 3.73435 19.0207V17.9927C3.73435 17.7994 3.89105 17.6427 4.08435 17.6427C4.27765 17.6427 4.43435 17.7994 4.43435 17.9927V19.0207C4.43435 19.214 4.27765 19.3707 4.08435 19.3707Z"
              fill="#FFD666"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M5.50525 20.1912C5.31195 20.1912 5.15525 20.0345 5.15525 19.8412V18.9527C5.15525 18.7594 5.31195 18.6027 5.50525 18.6027C5.69855 18.6027 5.85525 18.7594 5.85525 18.9527V19.8412C5.85525 20.0345 5.69855 20.1912 5.50525 20.1912Z"
              fill="#FFD666"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M6.92598 21.0307C6.73268 21.0307 6.57598 20.874 6.57598 20.6807V19.9127C6.57598 19.7194 6.73268 19.5627 6.92598 19.5627C7.11928 19.5627 7.27598 19.7194 7.27598 19.9127V20.6807C7.27598 20.874 7.11928 21.0307 6.92598 21.0307Z"
              fill="#FFD666"
            />
          </g>
          <path
            id="Path_2"
            d="M18.1105 19.32C18.008 19.3201 17.9106 19.2752 17.8441 19.1972L16.6841 17.8382C16.6018 17.7433 16.5768 17.6115 16.6185 17.493C16.6602 17.3744 16.7622 17.2874 16.8858 17.2648C17.0094 17.2422 17.1356 17.2876 17.2165 17.3838L18.1545 18.4827L21.2295 15.981C21.3264 15.9012 21.4587 15.8793 21.5761 15.9238C21.6935 15.9683 21.7781 16.0723 21.7977 16.1963C21.8174 16.3203 21.7692 16.4453 21.6713 16.5239L18.3313 19.2415C18.269 19.2924 18.1909 19.3201 18.1105 19.32Z"
            fill="#007867"
          />
          <g id="Vector_5">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M11.5888 18.0471C11.4302 18.0473 11.2914 17.941 11.2503 17.7879C11.2092 17.6347 11.2761 17.4731 11.4135 17.3939L13.008 16.4734C13.1163 16.4109 13.2497 16.4109 13.358 16.4734C13.4663 16.536 13.533 16.6515 13.533 16.7766C13.533 16.9016 13.4663 17.0172 13.358 17.0797L11.7635 18.0001C11.7104 18.0309 11.6501 18.0471 11.5888 18.0471Z"
              fill="#B76E00"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12.5425 11.3318C12.4653 11.25 12.3535 11.2103 12.242 11.2251C12.1305 11.2398 12.0329 11.3073 11.9797 11.4063L11.1347 12.9783C11.0763 13.0868 11.0793 13.2179 11.1424 13.3236C11.2055 13.4293 11.3195 13.4941 11.4427 13.4941C11.5732 13.4944 11.6937 13.4239 11.7573 13.3098L11.95 12.9624V15.9711C11.95 16.1644 12.1067 16.3211 12.3 16.3211C12.4933 16.3211 12.65 16.1644 12.65 15.9711V12.4526L12.9345 12.7604C12.9976 12.8278 13.0851 12.8673 13.1774 12.87C13.2697 12.8726 13.3593 12.8383 13.4263 12.7746C13.4936 12.7107 13.5328 12.6226 13.5352 12.5297C13.5376 12.4369 13.5029 12.3469 13.439 12.2796L12.5425 11.3318Z"
              fill="#B76E00"
            />
          </g>
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_0_8848"
          x1="14.3997"
          y1="12.8109"
          x2="23.9998"
          y2="22.4115"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#77ED8B" />
          <stop offset="1" stopColor="#22C55E" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_0_8848"
          x1="3.80957"
          y1="2.23462"
          x2="18.0556"
          y2="14.0791"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFAB00" />
          <stop offset="1" stopColor="#B76E00" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_0_8848"
          x1="3.80957"
          y1="2.23462"
          x2="18.0556"
          y2="14.0791"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFAB00" />
          <stop offset="1" stopColor="#B76E00" />
        </linearGradient>
      </defs>
    </svg>
  ),
  chat: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="icons/notification/ic_chat">
        <g id="stack">
          <path
            id="Path"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.9546 7.27183C20.3369 7.20489 23.9136 10.654 23.9985 15.0359C24.0109 15.6793 23.9466 16.3055 23.8141 16.9061C23.5898 17.9232 23.4564 18.9581 23.4564 19.9997V22.0128C23.4564 22.3213 23.2064 22.5713 22.898 22.5713H20.8848C19.8433 22.5713 18.8083 22.7047 17.7913 22.929C17.1907 23.0615 16.5645 23.1258 15.9211 23.1133C11.5392 23.0285 8.09012 19.4519 8.15696 15.0697C8.22216 10.7924 11.6773 7.33718 15.9546 7.27183Z"
            fill="url(#paint0_linear_0_8824)"
          />
          <path
            id="Path_2"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.80149 0.0425493C4.4627 -0.0390131 0.105251 4.16291 0.00184497 9.50132C-0.0132957 10.285 0.0650325 11.048 0.22647 11.7797C0.499751 13.0187 0.66222 14.2796 0.66222 15.5485V18.0011C0.66222 18.3768 0.966814 18.6815 1.34261 18.6815H3.7952C5.06402 18.6815 6.32491 18.8439 7.56395 19.1172C8.29567 19.2786 9.05861 19.357 9.84231 19.3418C15.1806 19.2384 19.3825 14.8811 19.3012 9.54242C19.2217 4.33147 15.0124 0.122096 9.80149 0.0425493Z"
            fill="url(#paint1_linear_0_8824)"
          />
          <g id="Vector" opacity="0.48">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M6.19693 9.17512C5.9243 8.88543 5.53843 8.70351 5.10915 8.70351C4.28354 8.70351 3.61426 9.37279 3.61426 10.1984C3.61426 10.6276 3.79613 11.0135 4.08587 11.2862L7.31059 14.5109C7.58326 14.8006 7.96913 14.9825 8.39837 14.9825C9.22398 14.9825 9.89326 14.3132 9.89326 13.4876C9.89326 13.0584 9.71134 12.6725 9.42165 12.3998L6.19693 9.17512Z"
              fill="#006C9C"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M10.4245 9.17512C10.1518 8.88543 9.76597 8.70351 9.33669 8.70351C8.51108 8.70351 7.8418 9.37279 7.8418 10.1984C7.8418 10.6276 8.02367 11.0135 8.31341 11.2862L11.5381 14.5109C11.8108 14.8006 12.1967 14.9825 12.6259 14.9825C13.4515 14.9825 14.1208 14.3132 14.1208 13.4876C14.1208 13.0584 13.9389 12.6725 13.6492 12.3998L10.4245 9.17512Z"
              fill="#006C9C"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M14.6518 9.1751C14.3792 8.88541 13.9933 8.70349 13.564 8.70349C12.7384 8.70349 12.0692 9.37277 12.0692 10.1984C12.0692 10.6276 12.2511 11.0135 12.5408 11.2862L15.7655 14.5109C16.0382 14.8006 16.424 14.9825 16.8533 14.9825C17.6789 14.9825 18.3482 14.3132 18.3482 13.4876C18.3482 13.0584 18.1662 12.6725 17.8765 12.3998L14.6518 9.1751Z"
              fill="#006C9C"
            />
          </g>
          <g id="Vector_2">
            <path
              d="M6.60404 10.1981C6.60404 11.0237 5.93475 11.693 5.10915 11.693C4.28354 11.693 3.61426 11.0237 3.61426 10.1981C3.61426 9.37253 4.28354 8.70325 5.10915 8.70325C5.93475 8.70325 6.60404 9.37253 6.60404 10.1981Z"
              fill="white"
            />
            <path
              d="M10.8314 10.1982C10.8314 11.0238 10.1621 11.6931 9.33649 11.6931C8.51088 11.6931 7.84159 11.0238 7.84159 10.1982C7.84159 9.37257 8.51088 8.70329 9.33649 8.70329C10.1621 8.70329 10.8314 9.37257 10.8314 10.1982Z"
              fill="white"
            />
            <path
              d="M15.0592 10.1982C15.0592 11.0238 14.3899 11.6931 13.5643 11.6931C12.7387 11.6931 12.0694 11.0238 12.0694 10.1982C12.0694 9.37257 12.7387 8.70329 13.5643 8.70329C14.3899 8.70329 15.0592 9.37257 15.0592 10.1982Z"
              fill="white"
            />
          </g>
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_0_8824"
          x1="8.15601"
          y1="7.27087"
          x2="24"
          y2="23.1149"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#77ED8B" />
          <stop offset="1" stopColor="#22C55E" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_0_8824"
          x1="0"
          y1="0.0413818"
          x2="19.3023"
          y2="19.3437"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00B8D9" />
          <stop offset="1" stopColor="#006C9C" />
        </linearGradient>
      </defs>
    </svg>
  ),
  mail: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="icons/notification/ic_mail">
        <path
          id="Vector"
          d="M0 8.99999L11.556 16.3545C11.688 16.452 11.844 16.5 12 16.5C12.156 16.5 12.312 16.452 12.444 16.3545L24 8.99999L12.45 0.149992C12.3201 0.052856 12.1622 0.000366211 12 0.000366211C11.8378 0.000366211 11.6799 0.052856 11.55 0.149992L0 8.99999Z"
          fill="#FFE9D5"
        />
        <path
          id="Vector_2"
          d="M19.5 0H4.5C3.6735 0 3 0.6735 3 1.5V18C3 18.414 3.336 18.75 3.75 18.75H20.25C20.664 18.75 21 18.414 21 18V1.5C21 0.6735 20.328 0 19.5 0Z"
          fill="#61F3F3"
        />
        <path
          id="Vector_3"
          d="M6.75 4.5H17.25C17.664 4.5 18 4.164 18 3.75C18 3.336 17.664 3 17.25 3H6.75C6.336 3 6 3.336 6 3.75C6 4.164 6.336 4.5 6.75 4.5ZM17.25 6H6.75C6.336 6 6 6.336 6 6.75C6 7.164 6.336 7.5 6.75 7.5H17.25C17.664 7.5 18 7.164 18 6.75C18 6.336 17.664 6 17.25 6ZM12.75 9H6.75C6.336 9 6 9.336 6 9.75C6 10.164 6.336 10.5 6.75 10.5H12.75C13.164 10.5 13.5 10.164 13.5 9.75C13.5 9.336 13.164 9 12.75 9Z"
          fill="#006C9C"
        />
        <path
          id="Vector_4"
          d="M12.444 16.3545C12.312 16.452 12.156 16.5 12 16.5C11.844 16.5 11.688 16.452 11.556 16.3545L0 9V22.5C0 23.328 0.672 24 1.5 24H22.5C23.328 24 24 23.328 24 22.5V9L12.444 16.3545Z"
          fill="url(#paint0_linear_0_8835)"
        />
        <path
          id="Vector_5"
          d="M22.5 24H1.5C0.6585 24 0 23.3415 0 22.5C6.7075e-05 22.3823 0.0277958 22.2663 0.0809492 22.1613C0.134103 22.0563 0.211192 21.9652 0.306 21.8955L11.556 14.3955C11.688 14.298 11.844 14.25 12 14.25C12.156 14.25 12.312 14.298 12.444 14.3955L23.694 21.8955C23.7888 21.9652 23.8659 22.0563 23.9191 22.1613C23.9722 22.2663 23.9999 22.3823 24 22.5C24 23.3415 23.3415 24 22.5 24Z"
          fill="#FF5630"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_0_8835"
          x1="0"
          y1="9"
          x2="13.4831"
          y2="30.573"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFAC82" />
          <stop offset="1" stopColor="#FF5630" />
        </linearGradient>
      </defs>
    </svg>
  ),
  delivery: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="icons/notification/ic_shipping">
        <g id="stack">
          <path
            id="Combined Shape"
            d="M23.9846 13.5663L20.4739 9.74142C20.2159 9.46006 19.8516 9.29989 19.4698 9.29993H15.1113V19.7723H16.7785C16.7785 18.4551 17.8463 17.3874 19.1634 17.3874C20.4806 17.3874 21.5484 18.4551 21.5484 19.7723H22.6217C22.9832 19.7724 23.3299 19.6288 23.5855 19.3732C23.8411 19.1175 23.9847 18.7708 23.9846 18.4093V13.5663Z"
            fill="url(#paint0_linear_0_8865)"
          />
          <path
            id="Path"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.1111 13.5665V19.7724H7.85246C7.85246 18.4551 6.78457 17.3872 5.46725 17.3872C4.14994 17.3872 3.08204 18.4551 3.08204 19.7724H1.3786C1.0171 19.7725 0.670387 19.6289 0.414766 19.3733C0.159146 19.1177 0.0155658 18.7709 0.015625 18.4094V7.03009C0.0155658 6.66859 0.159146 6.32188 0.414766 6.06626C0.670387 5.81063 1.0171 5.66706 1.3786 5.66711H2.85711C2.94212 8.0702 4.91485 9.97439 7.31944 9.97439C9.72402 9.97439 11.6968 8.0702 11.7818 5.66711H13.7481C14.5008 5.66718 15.111 6.27737 15.1111 7.03009V13.5665Z"
            fill="#FFAB00"
          />
          <path
            id="Path_2"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.7846 5.517C11.7846 5.56723 11.784 5.61746 11.7818 5.66714C11.6968 8.07022 9.72407 9.97441 7.31949 9.97441C4.9149 9.97441 2.94216 8.07022 2.85716 5.66714C2.85493 5.61746 2.85437 5.56723 2.85437 5.517C2.85437 3.05098 4.85347 1.05188 7.31949 1.05188C9.7855 1.05188 11.7846 3.05098 11.7846 5.517V5.517Z"
            fill="#61F3F3"
          />
          <g id="Vector">
            <path
              d="M21.5481 19.7724C21.5481 21.0895 20.4803 22.1573 19.1631 22.1573C17.846 22.1573 16.7782 21.0895 16.7782 19.7724C16.7782 18.4552 17.846 17.3875 19.1631 17.3875C20.4803 17.3875 21.5481 18.4552 21.5481 19.7724Z"
              fill="#B76E00"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M5.46696 17.3875C6.78412 17.3875 7.85189 18.4552 7.85189 19.7724C7.85189 21.0895 6.78412 22.1573 5.46696 22.1573C4.1498 22.1573 3.08203 21.0895 3.08203 19.7724C3.08206 18.4552 4.14981 17.3875 5.46696 17.3875Z"
              fill="#B76E00"
            />
          </g>
          <path
            id="Path_3"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.80965 7.30308C8.71048 7.30321 8.61499 7.26548 8.54269 7.1976L7.05246 5.80225C6.97358 5.72837 6.92882 5.62512 6.92883 5.51704V2.62141C6.92883 2.40563 7.10375 2.23071 7.31953 2.23071C7.53531 2.23071 7.71023 2.40563 7.71023 2.62141V5.34792L9.07678 6.62746C9.19385 6.73707 9.23205 6.90709 9.17312 7.05624C9.11418 7.20539 8.97008 7.30338 8.80971 7.30336L8.80965 7.30308Z"
            fill="#006C9C"
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_0_8865"
          x1="15.1113"
          y1="9.29993"
          x2="25.4416"
          y2="18.0528"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD666" />
          <stop offset="1" stopColor="#FFAB00" />
        </linearGradient>
      </defs>
    </svg>
  ),
  // Artham Money Transfer Icons
  transaction_success: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="12" fill="url(#paint_success)" />
      <path
        d="M7 12L10.5 15.5L17 9"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint_success"
          x1="0"
          y1="0"
          x2="24"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#77ED8B" />
          <stop offset="1" stopColor="#22C55E" />
        </linearGradient>
      </defs>
    </svg>
  ),
  transaction_failed: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="12" fill="url(#paint_failed)" />
      <path
        d="M12 7V13M12 17V17.5"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint_failed"
          x1="0"
          y1="0"
          x2="24"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF867C" />
          <stop offset="1" stopColor="#FF5630" />
        </linearGradient>
      </defs>
    </svg>
  ),
  high_value_transaction: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="12" fill="url(#paint_highvalue)" />
      <text x="12" y="17" fontSize="14" fontWeight="bold" fill="white" textAnchor="middle">
        ₹
      </text>
      <defs>
        <linearGradient
          id="paint_highvalue"
          x1="0"
          y1="0"
          x2="24"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD666" />
          <stop offset="1" stopColor="#FFAB00" />
        </linearGradient>
      </defs>
    </svg>
  ),
  cash_overdue: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="12" fill="url(#paint_overdue)" />
      <path
        d="M12 6V12L16 14"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint_overdue"
          x1="0"
          y1="0"
          x2="24"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF867C" />
          <stop offset="1" stopColor="#FF5630" />
        </linearGradient>
      </defs>
    </svg>
  ),
  cash_mismatch: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="12" fill="url(#paint_mismatch)" />
      <path
        d="M9 12H15M12 9V15"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 8L8 16"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint_mismatch"
          x1="0"
          y1="0"
          x2="24"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFB800" />
          <stop offset="1" stopColor="#FF5630" />
        </linearGradient>
      </defs>
    </svg>
  ),
  cash_reminder: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="12" fill="url(#paint_reminder)" />
      <path
        d="M12 8V12M12 16H12.01"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint_reminder"
          x1="0"
          y1="0"
          x2="24"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD666" />
          <stop offset="1" stopColor="#FFAB00" />
        </linearGradient>
      </defs>
    </svg>
  ),
  kyc_pending: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="12" fill="url(#paint_kyc)" />
      <circle cx="12" cy="9" r="3" stroke="white" strokeWidth="2" fill="none" />
      <path
        d="M6 19C6 16.2386 8.23858 14 11 14H13C15.7614 14 18 16.2386 18 19"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <defs>
        <linearGradient id="paint_kyc" x1="0" y1="0" x2="24" y2="24" gradientUnits="userSpaceOnUse">
          <stop stopColor="#90CAF9" />
          <stop offset="1" stopColor="#1976D2" />
        </linearGradient>
      </defs>
    </svg>
  ),
  pickup_assigned: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="12" fill="url(#paint_pickup)" />
      <path
        d="M9 11L12 8L15 11M12 8V16"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint_pickup"
          x1="0"
          y1="0"
          x2="24"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#77ED8B" />
          <stop offset="1" stopColor="#22C55E" />
        </linearGradient>
      </defs>
    </svg>
  ),
  pickup_completed: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="12" fill="url(#paint_pickup_done)" />
      <path
        d="M8 12L11 15L16 9"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint_pickup_done"
          x1="0"
          y1="0"
          x2="24"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#90CAF9" />
          <stop offset="1" stopColor="#1976D2" />
        </linearGradient>
      </defs>
    </svg>
  ),
  reconciliation: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="12" fill="url(#paint_recon)" />
      <path
        d="M7 8H17M7 12H17M7 16H13"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint_recon"
          x1="0"
          y1="0"
          x2="24"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B0BEC5" />
          <stop offset="1" stopColor="#607D8B" />
        </linearGradient>
      </defs>
    </svg>
  ),
  unusual_activity: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="12" fill="url(#paint_unusual)" />
      <path d="M12 6L7 12H12L12 18L17 12H12L12 6Z" fill="white" />
      <defs>
        <linearGradient
          id="paint_unusual"
          x1="0"
          y1="0"
          x2="24"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD666" />
          <stop offset="1" stopColor="#FF9800" />
        </linearGradient>
      </defs>
    </svg>
  ),
  beneficiary_verified: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="12" fill="url(#paint_verified)" />
      <path
        d="M9 12L11 14L15 10"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="12" cy="12" r="8" stroke="white" strokeWidth="1.5" fill="none" />
      <defs>
        <linearGradient
          id="paint_verified"
          x1="0"
          y1="0"
          x2="24"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#77ED8B" />
          <stop offset="1" stopColor="#22C55E" />
        </linearGradient>
      </defs>
    </svg>
  ),
  // New Notification Types
  transaction_approval_required: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="12" fill="url(#paint_approval)" />
      <path
        d="M12 8V12M12 16H12.01"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="12" cy="12" r="8" stroke="white" strokeWidth="1.5" fill="none" opacity="0.3" />
      <defs>
        <linearGradient
          id="paint_approval"
          x1="0"
          y1="0"
          x2="24"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFB800" />
          <stop offset="1" stopColor="#FF5630" />
        </linearGradient>
      </defs>
    </svg>
  ),
  credit_extension_request: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="12" fill="url(#paint_credit_req)" />
      <path
        d="M8 12H16M12 8V16"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <text x="18" y="8" fontSize="10" fontWeight="bold" fill="white" textAnchor="middle">
        ₹
      </text>
      <defs>
        <linearGradient
          id="paint_credit_req"
          x1="0"
          y1="0"
          x2="24"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#90CAF9" />
          <stop offset="1" stopColor="#1976D2" />
        </linearGradient>
      </defs>
    </svg>
  ),
  transaction_stuck: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="12" fill="url(#paint_stuck)" />
      <path
        d="M12 6V12L9 14.5"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="12" cy="12" r="8" stroke="white" strokeWidth="1.5" fill="none" opacity="0.3" />
      <defs>
        <linearGradient
          id="paint_stuck"
          x1="0"
          y1="0"
          x2="24"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF867C" />
          <stop offset="1" stopColor="#FF5630" />
        </linearGradient>
      </defs>
    </svg>
  ),
  transaction_approved: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="12" fill="url(#paint_approved)" />
      <path
        d="M7 12L10.5 15.5L17 9"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="12" cy="12" r="8" stroke="white" strokeWidth="1" fill="none" opacity="0.2" />
      <defs>
        <linearGradient
          id="paint_approved"
          x1="0"
          y1="0"
          x2="24"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#77ED8B" />
          <stop offset="1" stopColor="#22C55E" />
        </linearGradient>
      </defs>
    </svg>
  ),
  transaction_rejected: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="12" fill="url(#paint_rejected)" />
      <path
        d="M8 8L16 16M16 8L8 16"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint_rejected"
          x1="0"
          y1="0"
          x2="24"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF867C" />
          <stop offset="1" stopColor="#FF5630" />
        </linearGradient>
      </defs>
    </svg>
  ),
  info_requested: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="12" fill="url(#paint_info_req)" />
      <path
        d="M12 16V12M12 8H12.01"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint_info_req"
          x1="0"
          y1="0"
          x2="24"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD666" />
          <stop offset="1" stopColor="#FFAB00" />
        </linearGradient>
      </defs>
    </svg>
  ),
  credit_approved: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="12" fill="url(#paint_credit_approved)" />
      <path
        d="M8 12L11 15L16 10"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <text x="12" y="20" fontSize="8" fontWeight="bold" fill="white" textAnchor="middle">
        ₹+
      </text>
      <defs>
        <linearGradient
          id="paint_credit_approved"
          x1="0"
          y1="0"
          x2="24"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#90CAF9" />
          <stop offset="1" stopColor="#1976D2" />
        </linearGradient>
      </defs>
    </svg>
  ),
  credit_rejected: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="12" fill="url(#paint_credit_rejected)" />
      <path
        d="M8 8L16 16M16 8L8 16"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        opacity="0.8"
      />
      <text x="12" y="20" fontSize="8" fontWeight="bold" fill="white" textAnchor="middle">
        ₹
      </text>
      <defs>
        <linearGradient
          id="paint_credit_rejected"
          x1="0"
          y1="0"
          x2="24"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFB800" />
          <stop offset="1" stopColor="#FF5630" />
        </linearGradient>
      </defs>
    </svg>
  ),
  credit_low: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="12" fill="url(#paint_credit_low)" />
      <path
        d="M12 6V12M12 16H12.01"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 17L12 12L17 17"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        opacity="0.5"
      />
      <defs>
        <linearGradient
          id="paint_credit_low"
          x1="0"
          y1="0"
          x2="24"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD666" />
          <stop offset="1" stopColor="#FF9800" />
        </linearGradient>
      </defs>
    </svg>
  ),
  limit_approaching: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="12" fill="url(#paint_limit)" />
      <rect x="6" y="8" width="12" height="2" fill="white" opacity="0.3" />
      <rect x="6" y="11" width="12" height="2" fill="white" opacity="0.5" />
      <rect x="6" y="14" width="12" height="2" fill="white" opacity="0.8" />
      <defs>
        <linearGradient
          id="paint_limit"
          x1="0"
          y1="0"
          x2="24"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE082" />
          <stop offset="1" stopColor="#FFA726" />
        </linearGradient>
      </defs>
    </svg>
  ),
  pickup_urgent: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="12" fill="url(#paint_pickup_urgent)" />
      <path
        d="M9 11L12 8L15 11M12 8V16"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="18" cy="6" r="4" fill="#FF5630" />
      <path
        d="M18 4V6M18 8H18.01"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint_pickup_urgent"
          x1="0"
          y1="0"
          x2="24"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFB800" />
          <stop offset="1" stopColor="#FF9800" />
        </linearGradient>
      </defs>
    </svg>
  ),
  pickup_batch: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="12" fill="url(#paint_batch)" />
      <circle cx="8" cy="10" r="2" fill="white" />
      <circle cx="16" cy="10" r="2" fill="white" />
      <circle cx="12" cy="16" r="2" fill="white" />
      <path
        d="M10 11L8 10M14 11L16 10M10 15L12 16M14 15L12 16"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <defs>
        <linearGradient
          id="paint_batch"
          x1="0"
          y1="0"
          x2="24"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#90CAF9" />
          <stop offset="1" stopColor="#1976D2" />
        </linearGradient>
      </defs>
    </svg>
  ),
};
